export const mutations = {
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  setOpenId(state, id) {
    state.openId = id;
  },
  setCode(state, code) {
    state.code = code;
  },
};
